import React from 'react';

export interface SubscriptionChipProps {
  type: 'Expired' | 'Trial';
}

const SubscriptionChip = (props: SubscriptionChipProps) => {
  function bgColor(): string {
    switch (props.type) {
      case 'Trial':
        return 'bg-primary-navyblue-bright';
      case 'Expired':
        return 'bg-neutral-dust';
    }
  }

  return (
    <div
      className={
        'ml-1 inline-block rounded-lg py-1 px-2 text-neutral-whiteboard font-bold text-xxs leading-[10px] align-text-top ' +
        bgColor()
      }
    >
      {props.type}
    </div>
  );
};

export default SubscriptionChip;
